import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import { Divider } from '@mui/material'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    flexDirection: ({ isInline }) => isInline ? 'row' : 'column',
    alignItems: 'flex-start',
    position: 'relative',
    gap: 10,
  },
  items: {
    display: 'flex',
    padding: 3,
    border: theme.border,
    borderRadius: 100,
  },
  periodItem: {
    userSelect: 'none',
    display: 'flex',
    cursor: 'pointer',
    color: theme.textColor,
    fontSize: theme.fontSizes.smaller,
    borderRadius: 100,
    padding: '5px 15px',
    backgroundColor: !theme.isMeinbuero ? 'transparent' : theme.white,
  },
  active: ({ outlined }) => ({
    background: !outlined && (!theme.isMeinbuero ? theme.colorPrimaryButtonBackground : theme.primary),
    color: outlined ? theme.colorPrimaryButtonBackground : theme.white,
  }),
  readOnly: {
    opacity: 0.7,
    cursor: 'unset',
  },
  item: {
    display: 'flex',
    alignItems: 'stretch',
    position: 'relative',
  },
  divider: {
    borderLeft: theme.border,
    height: '70%',
  },
  icon: {
    position: 'absolute',
    top: -12,
    left: -5,
  },
  label: ({ isInline }) => ({
    alignSelf: isInline ? 'center' : 'flex-start',
    color: '#414a5f',
    fontSize: 13,
  }),
}))

export default function ItemSelection(props) {
  const { className, selectedItem, allItems, onItemClick, outlined = false, readOnly = false, label } = props
  const classes = useStyles(props)

  const items = allItems.map((period, index) => {
    const { label, value, className, icon } = period
    const showDivider = outlined && index !== allItems.length - 1

    return (
      <div key={value} className={clsx(ItemSelection.classNames.item, classes.item)}>
        {icon && <SVGIcon svg={icon} height="20px" width="20px" className={classes.icon} />}
        <span
          className={clsx(classes.periodItem, value === selectedItem && classes.active, readOnly && classes.readOnly, className)}
          onClick={() => !readOnly && onItemClick(value)}>
          {label}
        </span>
        {showDivider && <Divider orientation='horizontal' className={classes.divider} />}
      </div>
    )
  })

  const labelEl = label ? <label className={classes.label} disabled={readOnly}>{label}</label> : null

  return (
    <div className={clsx(className, classes.wrapper)}>
      {labelEl}
      <div className={clsx(ItemSelection.classNames.items, classes.items)}>
        {items}
      </div>
    </div>
  )
}

ItemSelection.propTypes = {
  className: PropTypes.string,
  onItemClick: PropTypes.func,
  allItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    icon: PropTypes.node,
    className: PropTypes.string,
  })).isRequired,
  selectedItem: PropTypes.string,
  label: PropTypes.string,
  isInline: PropTypes.bool,
  readOnly: PropTypes.bool,
  outlined: PropTypes.bool,
}

ItemSelection.classNames = {
  items: `${ItemSelection.name}-items`,
  item: `${ItemSelection.name}-item`,
}
